import { AFFAIR_FINAL_STAGES } from './affairModel';

const read = (row, camelKey, snakeKey) => row?.[camelKey] ?? row?.[snakeKey];
const validDate = (value) => { const date = value ? new Date(value) : null; return date && !Number.isNaN(date.getTime()) ? date : null; };
const isOpen = (affair) => !AFFAIR_FINAL_STAGES.includes(affair.stage);
const hasStarted = (affair) => (
  (affair.realizations || []).length > 0
  || (affair.projects || affair.Projects || []).length > 0
  || (affair.interventions || affair.Interventions || []).length > 0
);

export const calculateAffairMetrics = (affairs = [], nowValue = new Date()) => {
  const now = validDate(nowValue) || new Date();
  const openAffairs = affairs.filter(isOpen);
  return {
    toAnalyze: affairs.filter((affair) => ['to_qualify', 'qualified'].includes(affair.stage)).length,
    potentialAmount: openAffairs.reduce((sum, affair) => sum + Number(read(affair, 'estimatedAmount', 'estimated_amount') || 0), 0),
    quotesToFinish: affairs.filter((affair) => affair.stage === 'estimating').length,
    awaitedResponses: affairs.filter((affair) => ['offer_sent', 'negotiation'].includes(affair.stage)).length,
    followUpsToDo: openAffairs.filter((affair) => { const due = validDate(read(affair, 'nextFollowUpAt', 'next_follow_up_at')); return due && due <= now; }).length,
    acceptedToStart: affairs.filter((affair) => affair.stage === 'won' && !hasStarted(affair)).length,
  };
};
